import { t } from "../../i18n";
import { CheckCircle2, HardDrive, Server } from "lucide-react";
import { asRecord } from "./ToolResultView.utils";
import { Card } from "./WorkspaceResultCard";
import { FileList } from "./WorkspaceResultFileList";
import { Heading } from "./WorkspaceResultHeading";
import { recordValue, text, titleCase } from "./WorkspaceResult.utils";

export function ProxmoxResult({
  name,
  result,
}: {
  name: string;
  result: unknown;
}) {
  const rows = Array.isArray(result) ? result : [];
  const value = recordValue(result);
  if (name === "proxmox_target_power")
    return (
      <Card tone="emerald">
        <Heading
          icon={
            <CheckCircle2
              size={16}
              className="text-emerald-700 dark:text-emerald-300"
            />
          }
        >
          {t("Power action completed")}
        </Heading>
      </Card>
    );
  if (rows.length)
    return (
      <FileList
        paths={rows.map((item) => {
          const row = asRecord(item);
          return [
            text(row?.name),
            text(row?.node),
            text(row?.type),
            text(row?.status),
          ]
            .filter(Boolean)
            .join(" · ");
        })}
        title={
          name === "proxmox_inventory"
            ? t("Proxmox inventory")
            : t("Proxmox resources")
        }
        icon={<Server size={16} className="text-sky-700 dark:text-sky-300" />}
      />
    );
  const metrics = Object.entries(value).filter(([, item]) =>
    ["string", "number", "boolean"].includes(typeof item),
  );
  return (
    <Card tone="sky">
      <Heading
        icon={
          <HardDrive size={16} className="text-sky-700 dark:text-sky-300" />
        }
      >
        {name === "proxmox_target_status"
          ? t("Workspace status")
          : t("Workspace resources")}
      </Heading>
      <div className="mt-3 grid gap-2 sm:grid-cols-2">
        {metrics.slice(0, 10).map(([key, item]) => (
          <div
            key={key}
            className="rounded-lg bg-white/70 px-2.5 py-2 dark:bg-black/10"
          >
            <div className="text-[10px] font-semibold text-stone-400 uppercase">
              {titleCase(key)}
            </div>
            <div className="mt-0.5 truncate text-sm font-semibold">
              {String(item)}
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
}
